/**
 * 更新paypal支付
 **/
function updatePaypal (params) {
  paypal.Messages({
    amount: params,
    style: {
      layout: "text",
      logo: {
        type: "primary"
      },
      text: {
        color: "black",
        size: 14
      }
    }
  }).render('#is-paypal');
}



(() => {
  class t extends HTMLElement {
    constructor() {
      super();
      this.main = this.closest("main-product");
      this.addEventListener("change", this.onVariantChange);
      this.updateCode()
      this.initProductDiscounts()
      this.modalDiscounts()
      this.handelEvents();
      this.cartOffcanvas = document.querySelector("header-cart-dropdown");
    }
    // 监听加购事件
    handelEvents () {
      let addToCartEl = document.querySelectorAll("[data-add-to-cart]")
      addToCartEl.forEach((addToCart) => {
        addToCart.addEventListener("click", (el) => {
          el.stopPropagation();
          el.preventDefault();
          this.addToCart();
        });
      });
    }
    // 加购事件
    async addToCart () {
      const toast = this.querySelector("toast-message");
      const selectData = this.getSelectItems();
      this.toggleAddToCartState(true);
      const { status, description } = await this.addPt(selectData);
      if (status) {
        toast.show(description);
        this.toggleAddToCartState();
        return;
      }

      const cartData = await this.getCartData();
      this.cartOffcanvas.renderContents(cartData);

      UIkit.offcanvas(this.cartOffcanvas).show();
      document.querySelector('.cart-offcanvas-nav-total-price [data-page-type="cart"]')?.setAttribute("data-amount", cartData.total_price);
      setTimeout(() => {
        affirm.ui.refresh();
      }, 10);

      this.toggleAddToCartState();
    }

    // TODO: 获取购物车数据(兼容老主题)
    async getCartData () {
      const body = JSON.stringify({
        sections: this.cartOffcanvas.getSectionsToRender().map((t) => t.section),
        sections_url: window.location.pathname,
      });
      return fetch(window.routes.cart_update_url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: body,
      })
        .then((res) => res.text())
        .then((res) => JSON.parse(res));
    }

    // 添加购物车
    async addPt (items) {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ items }),
      })
        .then((res) => res.json())
        .catch((err) => err.json());

      return res;
    }
    //加购按钮状态
    toggleAddToCartState (state = false) {
      let addToCartEl = document.querySelectorAll("[data-add-to-cart]")
      // 更新所以的加购按钮的状态
      addToCartEl.forEach((el) => {
        el.disabled = state;
        const addToCartLoadding = el.querySelector("[data-loadding]");
        const addToCartContent = el.querySelector("[data-content]");
        addToCartLoadding?.classList.toggle("uk-hidden", !state);
        addToCartContent?.classList.toggle("uk-hidden", state);
      });
    }


    modalDiscounts () {
      UIkit.util.on('#modal-product-discounts', 'show', function () {
        var modalDiscountedPriceEl = document.querySelector("[data-modal-discounted-price]");
        var modalRebatesPriceEl = document.querySelector("[data-modal-rebates-price]");

        var modalRebatesImgEl = document.querySelector("[data-modal-discounted-img]");
        var modalRebatesTitleEl = document.querySelector("[data-modal-discounted-title]");
        let currentVariant = this.currentVariant;
        let price = this.main.dataset.price;
        let title = this.main.dataset.title;
        let img = this.main.dataset.img;
        if (currentVariant) {

          price = currentVariant.price / 100;
          title = currentVariant.title;
          img = currentVariant.featured_image.src;
        }
        let obj = this.discountedPriceF(price)
        modalDiscountedPriceEl.textContent = obj.discountedPrice;
        modalRebatesPriceEl.textContent = obj.rebatesPrice;
        modalRebatesTitleEl.textContent = title;
        modalRebatesImgEl.setAttribute('src', img);
      }.bind(this));
    }
    initProductDiscounts () {
      var price = this.main.dataset.price;
      this.updateProductDiscounts(price)
    }
    updateProductDiscounts (price) {
      var discountedPriceEl = this.main.querySelector("[data-discounted-price]");
      var rebatesPriceEl = this.main.querySelector("[data-rebates-price]");
      if (!discountedPriceEl || !rebatesPriceEl) return;
      let obj = this.discountedPriceF(price)
      // 回扣价格
      discountedPriceEl.textContent = obj.discountedPrice;
      rebatesPriceEl.textContent = obj.rebatesPrice;
    }
    discountedPriceF (price) {
      // 优惠30%后的价格
      var discountedPrice = price * 0.7;

      // 判断小数部分是否大于0
      if (discountedPrice % 1 > 0) {
        // 保留2位小数
        discountedPrice = Math.floor(discountedPrice * 100) / 100;
      } else {
        // 如果小数部分为0，则直接取整
        discountedPrice = Math.floor(discountedPrice);
      }
      // 判断小数部分是否大于0
      var rebatesPrice = price - discountedPrice;

      // 回扣价格
      if (discountedPrice % 1 > 0) {
        // 保留2位小数
        rebatesPrice = Math.floor(rebatesPrice * 100) / 100;
      } else {
        // 如果小数部分为0，则直接取整
        rebatesPrice = Math.floor(rebatesPrice);
      }
      let obj = {
        rebatesPrice: ` $${rebatesPrice.toLocaleString()} `,
        discountedPrice: ` $${discountedPrice.toLocaleString()} `
      }
      return obj
    }
    onVariantChange () {
      this.updateOptions(),
        this.updateMasterId(),
        this.updateSelectInfo(),
        this.toggleAddButton(!0, "", !1),

        this.removeErrorMessage(),
        this.currentVariant ? (this.updateMedia(),
          this.updateURL(),
          this.updateVariantInput(),
          this.renderProductInfo()) : (this.toggleAddButton(!0, "", !0),
            this.setUnavailable())
      this.updateCode();
      this.updateTotalInfo();

    }
    // 获取被选中列表
    getSelectItems () {
      const items = [];
      const bundleSelects = document.querySelectorAll('[data-select="true"]');

      // 加入主产品
      const t = Array.from(document.querySelectorAll("[data-options]"));
      let data = t.map(t => Array.from(t.querySelectorAll("input")).find(t => t.checked));
      let obj = {
        id: data[0].dataset.id,
        sku: data[0].dataset.sku,
        price: data[0].dataset.affirm * 1,
        compare_at_price: data[0].dataset.compare_at_price * 1,
        quantity: 1
      }
      items.push(obj);

      // 加入选中的产品
      bundleSelects.forEach((select) => {
        items.push(select.currentVariant);
      });

      return items;
    }

    // 计算选中的产品的总价/总折扣价
    computeSubtotal (items) {
      let subtotal = 0;
      let compareAtPriceSubtotal = 0;
      let code = 0;
      items.map((item) => {
        subtotal += item.price * (item.quantity || 1);
        compareAtPriceSubtotal += item.compare_at_price * (item.quantity || 1);
      });
      code = compareAtPriceSubtotal - subtotal
      return { subtotal, compareAtPriceSubtotal, code };
    }
    // 更新悬浮价格
    updateTotalInfo () {
      const items = this.getSelectItems() || [];
      const { subtotal, compareAtPriceSubtotal, code } = this.computeSubtotal(items);
      const t = Array.from(this.querySelectorAll("[data-options]"));
      // var dataInfo = t.map(t => Array.from(t.querySelectorAll("input")).find(t => t.checked).dataset);
      var dataInfo = [{
        "sku": "",
        "affirm": subtotal,
        "compare_at_price": compareAtPriceSubtotal,
        "price": formatMoney(subtotal),
        "code": formatMoney(code),
        "compare": formatMoney(compareAtPriceSubtotal),
        "tax": true
      }]

      document.querySelector("#change-total-price .product__price").innerHTML = dataInfo[0].price;
      document.querySelector("#change-total-price .product__compare-at-price").innerHTML = dataInfo[0].compare;

      document.querySelector(".product-bottom-cta-box .affirm-as-low-as").setAttribute("data-amount", subtotal);
      document.querySelector(".product-bottom-cta-box .affirm-as-low-as").setAttribute("data-sku", dataInfo[0].sku);
      affirm.ui.refresh();
      

      if (dataInfo[0].code) {
        document.querySelector("#change-total-price .product__compare-at").innerHTML = "-" + dataInfo[0].code;
        document.querySelector("#change-total-price .product__compare-at").style.display = "inline"
      } else {
        document.querySelector("#change-total-price .product__compare-at").style.display = "none"
      }
      if (dataInfo[0].tax) {
        document.querySelector(".product-discounts-box").style.display = "block";
      } else {
        document.querySelector(".product-discounts-box").style.display = "none";
      }
    }
    updateOptions () {
      const t = Array.from(this.querySelectorAll("[data-options]"));
      this.options = t.map(t => Array.from(t.querySelectorAll("input")).find(t => t.checked).value);
    }
    updateMasterId () {
      this.currentVariant = this.getVariantData().find(t => !t.options.map((t, e) => this.options[e] === t).includes(!1))
    }
    updateMedia () {
      this.currentVariant && this.currentVariant.featured_media && this.main.thumbnailImageSlide(this.currentVariant.featured_media.id)
    }
    updateURL () {
      this.currentVariant && -1 !== location.pathname.indexOf("/products/") && window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
      window.affirm && window.affirm.ui.refresh();
    }
    updateVariantInput () {
      document.querySelectorAll(`#product-form-${this.dataset.section},#product-form-installment`).forEach(t => {
        const e = t.querySelector('input[name="id"]');
        e.value = this.currentVariant.id,
          e.dispatchEvent(new Event("change", {
            bubbles: !0
          }))
      }
      )
    }
    async renderProductInfo () {
      const t = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=` + this.dataset.section
        , e = "price-" + this.dataset.section
        , a = document.getElementById(e);
       const fixedButtom = document.querySelector(".fixed-buy-info").getAttribute("id");
       const fixedList = fixedButtom.split("shopify-section-");
       const other  = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=`+fixedList[1];

      // 切换变体修改优惠价格
      this.updateProductDiscounts(this.currentVariant.price / 100)

      this.source = await fetch(t).then(t => t.text()).then(t => (new DOMParser).parseFromString(t, "text/html").getElementById(e));
      this.source && a && (a.innerHTML = this.source.innerHTML);

      this.payInfo = await fetch(other).then((t) => t.text()) .then((t) => new DOMParser().parseFromString(t, "text/html").getElementById("shop-pay-info"));
      if(this.payInfo && document.querySelector(".show-shop-pay-area")){
        document.querySelector(".show-shop-pay-area").innerHTML = this.payInfo.innerHTML;
        document.querySelector(".top-shop-pay-area").innerHTML = this.payInfo.innerHTML;
        
      }
      
      
        document.getElementById("price-" + this.dataset.section).classList.remove("visibility-hidden");
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);

    }
    toggleAddButton (t = !0, e, a) {
      const r = document.querySelector(".product-bottom-cta").querySelector('[name="add"]')
        , s = document.querySelector(".product-bottom-cta").querySelector('[name="add"]').querySelector("span");
      r && (t ? (r.setAttribute("disabled", !0),
        e && (s.textContent = e)) : (r.removeAttribute("disabled"),
          s.textContent = window.variantStrings.addToCart))
    }
    setUnavailable () {
      const t = document.querySelector(".product-bottom-cta").querySelector('[name="add"]'), e = document.querySelector(".product-bottom-cta").querySelector('[name="add"]').querySelector("span");
      t && (e.textContent = window.variantStrings.unavailable,
        document.getElementById("price-" + this.dataset.section).classList.add("uk-hidden"))
    }
    getVariantData () {
      return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent), this.variantData
    }
    removeErrorMessage () {
      const t = this.closest("section");
      if (t) {
        const e = t.querySelector("product-form");
        e && e.handleErrorMessage()
      }
    }
    updateSelectInfo () {
      const t = window.Shopify || {}
        , { id: e, price: a, title: r } = this.currentVariant;
      t.selected_variant = Object.assign(t.selected_variant || {}, {
        value: a / 100,
        content_ids: [e.toString()],
        content_name: r
      })
    }

    updateCode () {
      let tm_discount = this.main.querySelector('.tm-discount-variant')
      let tm_discount_code = this.main.querySelector('.tm-discount-code')
      let tm_discount_date = this.main.querySelector('.tm-discount-date')
      let tm_discount_des = this.main.querySelector('.tm-discount-des')
      let tm_discount_coupon = this.main.querySelector('.tm-discount-coupon')
      const url = window.location.href;
      const { url: urlWithoutParams, paramValue } = this.parseUrl(url, 'variant');
      fetch(`${urlWithoutParams}?view=json`)
        .then(response => response.json())
        .then(responseData => {
          // 在此处对 responseData 进行处理
          if (responseData && responseData.coupon != null) {
            let coupon = responseData.coupon
            const foundObjs = coupon.filter(obj => obj.hasOwnProperty(paramValue));
            if (foundObjs.length <= 0 || tm_discount == null) return;

            if (foundObjs[0][paramValue] != null) {
              tm_discount.setAttribute("style", "display: block !important")
              tm_discount.dataset.discount = foundObjs[0][paramValue].code;
              tm_discount_code.innerHTML = foundObjs[0][paramValue].code;
              tm_discount_date.innerHTML = foundObjs[0][paramValue].start + '~' + foundObjs[0][paramValue].end;
              tm_discount_des.innerHTML = foundObjs[0][paramValue].des;
              tm_discount_coupon.innerHTML = foundObjs[0][paramValue].coupon;
            } else {
              tm_discount.setAttribute("style", "display: none !important")
            }
          } else {
            tm_discount.setAttribute("style", "display: none !important")
          }
        });
    }
    removeQueryParams (url) {
      const index = url.indexOf('?');
      if (index !== -1) {
        return url.substring(0, index);
      } else {
        return url;
      }
    }
    parseUrl (url, paramName) {
      const urlObj = new URL(url);
      const params = new URLSearchParams(urlObj.search);
      const paramValue = params.get(paramName);
      return {
        url: urlObj.origin + urlObj.pathname,
        paramValue: paramValue
      };
    }
  }
  customElements.define("variant-radios", t);
  class e extends HTMLElement {
    constructor() {
      super(),

        this.selectors = {
          slideshowElement: this.querySelector("[uk-slideshow]"),
          sliderElement: this.querySelector("[uk-slider]")
        },
        this.thumbnailImageClick();
    }
    thumbnailImageClick () {
      var t = UIkit.util.queryAll("[uk-slider] [data-index]");
      UIkit.util.on(t, "click", t => {
        let variantId = t.target.dataset.thumbnailId
        this.thumbnailImageSlide(variantId)
        // 点击切换图片
      })
    }
    getVariantData () {
      return this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent),
        this.variantData
    }
    thumbnailImageSlide (t) {
      var e = this.querySelector(`[data-media-id="${t}"]`);
      e && (UIkit.util.removeClass(UIkit.util.queryAll("[uk-slider] [data-thumbnail-id]"), "tm-active"),
        this.querySelector(`[data-thumbnail-id="${t}"]`).classList.add("tm-active"),
        UIkit.slideshow(this.selectors.slideshowElement).show(e.dataset.imageIndex),
        UIkit.slider(this.selectors.sliderElement).show(e.dataset.imageIndex))

      // 更新优惠价
      const variantData = this.getVariantData();
      if (Array.isArray(variantData)) {
        if (this.getVariantData()) {
          let obj = this.getVariantData().find(item => item.featured_media.id == t);
          // 当存在值的时候展示值 没有值的时候就隐藏
          if (obj && (obj.compare_at_price > obj.price)) {
            document.querySelector('.discount-label').classList.remove("discount-hide");
            document.querySelector("#discount-label-price").innerHTML = ((obj.compare_at_price - obj.price) / 100).toFixed(0);
          } else {
            document.querySelector('.discount-label').classList.add("discount-hide")
          }
        }
      }
    }
  }
  customElements.define("main-product", e);
  class a extends HTMLElement {
    constructor() {
      super(),
        this.form = this.querySelector("form"),
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this)),
        this.cartOffcanvas = document.querySelector("header-cart-dropdown");
       document.querySelector(".show-shop-pay-area").innerHTML = document.querySelector(".shop-pay-info").innerHTML;
      document.querySelector(".top-shop-pay-area").innerHTML = document.querySelector(".shop-pay-info").innerHTML;
      
    }
    onSubmitHandler (t) {
      t.preventDefault(),
        this.handleErrorMessage();
      const e = this.querySelector('[type="submit"]')
        , a = (e.setAttribute("disabled", !0),
          e.classList.add("loading"),
        {
          method: 'POST'
        });
      a.body = new FormData(this.form);
      try {
        // qp("track", "AddToCart");
        mkq("track", "AddToCart", shopify.selected_variant);
        gtag("event", "add_to_cart");
        (rtbhEvents = window.rtbhEvents || []).push({
          eventType: 'basketadd',
          offerId: this.closest("[data-main-product]").dataset.mainProduct
        });
      } catch (t) { }
      fetch(routes.cart_add_url + ".js", a).then(t => t.json()).then(async t => {
        if (t.status)
          this.handleErrorMessage(t.description);
        else {
          this.pushAddToCartEvent(t);
          var e = await this.getCartData();
          this.cartOffcanvas.renderContents(e),
            UIkit.offcanvas(this.cartOffcanvas).show();
        }
      }
      ).catch(t => {
          UIkit.offcanvas(this.cartOffcanvas).hide()
      }
      ).finally(() => {
        e.classList.remove("loading"),
          e.removeAttribute("disabled")
      }
      )
    }
    handleErrorMessage (t = !1) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector("[data-error-message-wrapper]") || null,
        this.errorMessageWrapper && (this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector("[data-error-message]") || null,
          this.errorMessageWrapper && this.errorMessageWrapper.toggleAttribute("hidden", !t),
          t && this.errorMessage && (this.errorMessage.textContent = t))
    }
    async getCartData () {
      var t = JSON.stringify({
        sections: this.cartOffcanvas.getSectionsToRender().map(t => t.section),
        sections_url: window.location.pathname
      });
      return fetch("" + routes.cart_update_url, {
        ...Shopify.fetchConfig(),
        body: t
      }).then(t => t.text()).then(t => JSON.parse(t))
    }
    pushAddToCartEvent(responseData) {
      if (window.GA4Ecommerce) {
        window.GA4Ecommerce.pushAddToCartEvent(responseData);
      }
    }
  }
  customElements.define("product-form", a)
}
)();

// 货币格式
function formatMoney (cents, format) {
  var moneyFormat = "US${{amount}}";
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  let value = '';
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;

  function formatWithDelimiters (
    number,
    precision = 2,
    thousands = ',',
    decimal = '.'
  ) {
    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    const parts = number.split('.');
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : '';

    return dollarsAmount + centsAmount;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
}